import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Order } from '../../../common/model/dto/order/order';
import { OrderDataUtils } from '../../../common/utils/services/order-data-utils';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';
import OvOrderDiscount from './OvOrderDiscount';

interface OvOrderTotalSummaryProps {
  order: Order;
}

const OvOrderTotalSummary: FC<OvOrderTotalSummaryProps> = ({ order }) => {
  const { t } = useTranslation();

  return (
    <>
      <strong>
        {OrderDataUtils.formatAmount(OrderDataUtils.getTotal(order))}
      </strong>
      <Secondary>
        {t('orders.itemCount', { count: OrderDataUtils.getItemCount(order) })}
      </Secondary>
      <OvOrderDiscount order={order} />
    </>
  );
};

export default OvOrderTotalSummary;

const Secondary = styled.span`
  display: block;
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.SMALL};
`;
